import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { defineComponent, nextTick, onMounted, ref, toRefs, watch } from "@vue/composition-api";
import Select2 from "@Shared/components/inputs/select2.vue";
import { useI18n } from "vue-i18n-composable";
import ReferrersDropdownTemplate from "@Broker/@HandlebarsTemplates/clients/board/table/_referrers-dropdown.hbs";
import { MAIN_API } from "@Shared/utils/constants";
import { useAccountStoreState } from "@Broker/@Modules/main/store/account/account-helpers";
export default defineComponent({
  name: "ServerSideReferrersSelect",
  components: {
    Select2
  },
  props: {
    id: {
      type: String,
      required: true
    },
    preSelectedReferrer: {
      type: [Array, Object],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    labelKey: {
      type: String,
      default: "global.doorr.referrer"
    }
  },
  setup(props, {
    emit
  }) {
    var _preSelectedReferrer$, _preSelectedReferrer$2;
    const {
      t
    } = useI18n();
    const {
      preSelectedReferrer,
      multiple,
      id,
      closeOnSelect
    } = toRefs(props);
    const referrersSelect = ref();
    const referrerId = ref((_preSelectedReferrer$ = (_preSelectedReferrer$2 = preSelectedReferrer.value) == null ? void 0 : _preSelectedReferrer$2.id) != null ? _preSelectedReferrer$ : null);
    const {
      apiBasePath,
      userDetails,
      token
    } = useAccountStoreState(["apiBasePath", "userDetails", "token"]);
    onMounted(() => {
      setSelectedData();
    });
    watch(() => props.preSelectedReferrer, (newVal, oldVal) => {
      if (newVal === oldVal) return;
      nextTick(() => {
        setSelectedData();
      });
    }, {
      immediate: false,
      deep: true
    });
    const setSelectedData = () => {
      var _referrersSelect$valu2;
      if (!preSelectedReferrer.value) return;
      const select = $(`#${id.value}`);
      if (!multiple.value) {
        var _referrersSelect$valu;
        _findInstanceProperty(select).call(select, `option[value="${referrerId.value}"]`).remove();
        const option = new Option(`${preSelectedReferrer.value.givenName} ${preSelectedReferrer.value.familyName}`, referrerId.value, true, true);
        select.append(option).trigger("change");
        (_referrersSelect$valu = referrersSelect.value) == null ? void 0 : _referrersSelect$valu.setValue(preSelectedReferrer.value.id);
        return;
      }
      const selectedIds = [];
      for (const referrer of preSelectedReferrer.value) {
        const option = new Option(`${referrer.givenName} ${referrer.familyName}`, referrer.id, true, true);
        select.append(option).trigger("change");
        selectedIds.push(referrer.id);
      }
      referrerId.value = selectedIds;
      (_referrersSelect$valu2 = referrersSelect.value) == null ? void 0 : _referrersSelect$valu2.setValue(selectedIds);
    };
    const handleSelect2Click = event => {
      var _context;
      if (_includesInstanceProperty(_context = ["no-results-span", "no-results-btn"]).call(_context, event.target.id)) {
        var _referrersSelect$valu3;
        const text = $(`#${id.value}-container .select2-search__field`).val();
        referrersSelect == null ? void 0 : (_referrersSelect$valu3 = referrersSelect.value) == null ? void 0 : _referrersSelect$valu3.close();
        const [givenName = "", ...familyNames] = text.split(" ");
        const familyName = familyNames.join(" ");
        nextTick(() => {
          emit("handle-referrer", {
            referrerId: null,
            referrerData: {
              givenName,
              familyName
            }
          });
        });
      }
    };
    const formatReferrerSelection = data => {
      return data.givenName && data.familyName ? `${data.givenName} ${data.familyName}` : data.text;
    };
    const options = () => {
      const createAsNewReferrer = t("referrers.actions.createAsNewReferrer");
      const formatResult = state => {
        return $(ReferrersDropdownTemplate(_objectSpread(_objectSpread({}, state), {}, {
          type: t("referrers.referrerType")[state.type],
          createAsNewReferrer,
          element: true,
          text: state.loading ? `${t("client-profile.messages.searchingReferrers")}...` : `${state.givenName} ${state.familyName}`
        })));
      };
      return {
        ajax: {
          url: `${MAIN_API}${apiBasePath.value}/${userDetails.value.username}/client/referrer`,
          type: "GET",
          data: params => {
            var _params$page;
            const offset = (((_params$page = params.page) != null ? _params$page : 1) - 1) * 20;
            return {
              searchString: params.term,
              limit: 20,
              offset
            };
          },
          headers: {
            "content-type": "application/json",
            "x-auth-token": token.value
          },
          processResults: (data, params) => {
            const page = params.page ? params.page : 1;
            return {
              results: data.referrers,
              pagination: {
                more: page * 20 < data.referrerCount
              }
            };
          },
          dataType: "json",
          delay: 250
        },
        dropdownParent: `#${id.value}-container`,
        dropdownCssClass: "client-profile-referrer-select",
        allowClear: true,
        closeOnSelect: closeOnSelect.value,
        placeholder: t("global.words.none"),
        minimumInputLength: 3,
        templateResult: formatResult,
        templateSelection: formatReferrerSelection,
        language: {
          noResults() {
            const text = $(`#${id.value}-container .select2-search__field`).val();
            return `
              <button class="no-results-btn d-flex flex-column bold" id="no-results-btn"> ${text}
                <span class="grey-text font-italic font-weight-normal" style="pointer-events: none;">
                  ${createAsNewReferrer}
                </span>
              </button>`;
          }
        },
        escapeMarkup(markup) {
          return markup;
        }
      };
    };
    const formatData = data => {
      return data && _mapInstanceProperty(data).call(data, ref => {
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      });
    };
    const updateReferrer = (referrer, type) => {
      switch (type) {
        case "unselect":
          if (!multiple.value) {
            referrerId.value = null;
            break;
          }
          break;
        case "select":
          if (!multiple.value) {
            referrerId.value = referrer.id;
            break;
          }
          referrerId.value.push(referrer.id);
          break;
      }
      emit("change", {
        referrer,
        type
      });
    };
    return {
      handleSelect2Click,
      options,
      formatData,
      updateReferrer,
      referrerId,
      referrersSelect,
      setSelectedData
    };
  }
});